import { render, staticRenderFns } from "./card-tertiary.vue?vue&type=template&id=28a6dcc0&scoped=true&"
import script from "./card-tertiary.vue?vue&type=script&lang=js&"
export * from "./card-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a6dcc0",
  null
  
)

export default component.exports